//librerias
import { Component, OnInit } from "@angular/core";
//servicios
import { CoursesCatalogService } from "src/app/services/coursesCatalogAdmin/courses-catalog.service";
//interfaces
import { LOInterface } from "src/app/models/Interfaces/LOInterface";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalCourseCardComponent } from "src/app/cursos/components/modalCourseCard/modal-course-card.component";
import { Router } from "@angular/router";
import { MyModalCourseCardComponent } from "src/app/cursos/components/my-modal-course-card/my-modal-course-card.component";

/*
  ****************************
  Esta sección del código no se utiliza actualmente fue deshabilitada de las rutas a petición del cliente
  se mantiene en caso de que se vuelva a requerir

  Anteriormente existían dos módulos cursos y misCursos -> ambos eran casi idénticos y sonarQube marcaba código replicado.
  Para solventar esto, se mantuvo un solo módulo y este se adapto para tener ambas funcionalidades.
  Revisando el código anterior lo único diferente entre ambos módulos era el modal.

  ****************************
  *
 */
@Component({
  selector: "app-courses-catalog",
  templateUrl: "./courses-catalog.component.html",
  styleUrls: ["./courses-catalog.component.css"],
})
export class CoursesCatalogComponent implements OnInit {
  cursos!: LOInterface;
  flag = false;
  spinner = true;

  // Variables de paginación
  currentPage: number = 1;
  itemsPerPage: number = 6; //cursos por página
  totalPages: number = 0;
  pages: number[] = [];
  cursosToShow: any[] = [];
  constructor(
    private coursesService: CoursesCatalogService,
    private modalService: NgbModal,
    private router: Router
  ) {}
  ngOnInit(): void {
    if (!this.flag) {
      /*
        ****************************
          cuando existían los módulos cursos y misCursos, en ambos se hacia la misma petición
          esto debe revisarse debido a que cuando es cursos se deberían mostrar de forma global
          y con mis cursos se deberían mostrar solo los cursos del usuario

        ****************************
      */
      this.coursesService.getCoursesCornerList().subscribe(data => {
        if (data.totalRecords != undefined && data.totalRecords >= 1) {
          this.cursos = data;
          this.calculateTotalPages();
          this.updateCursosToShow();
        } else {
          alert("Error al cargar Información");
        }
        this.spinner = false;
      });
      this.flag = true;
    }
  }

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.cursos?.data.length / this.itemsPerPage);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  updateCursosToShow() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.cursosToShow = this.cursos?.data.slice(startIndex, endIndex);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateCursosToShow();
    }
  }

  openModal($curso: any) {
    const trimmedUrl = this.router.url.trim();
    let modalRef: NgbModalRef;
    if (trimmedUrl.endsWith("myCourses")) {
      modalRef = this.modalService.open(MyModalCourseCardComponent, {
        size: "lg",
        centered: true,
        backdrop: "static",
      });
    } else {
      modalRef = this.modalService.open(ModalCourseCardComponent, {
        size: "lg",
        centered: true,
        backdrop: "static",
      });
    }

    modalRef.componentInstance.data = $curso;
  }
}
